<template>
  <div class="game-props">
    <div v-if="quest">
      <h2 class="sub-heading">{{$store.state.currentGame.quest.name}}</h2>
    </div>
    <div v-if="character">
      <figure>
        <!-- <font-awesome-icon icon="user" class="fa-7x" style="margin: 1rem" /> -->
        <img :src="character.avatar.fields.file.url + '?q=50'"
          :alt="character.avatar.fields.file.name">
        <figcaption>
          <span class="game-props__name">{{character.name}}</span>
        </figcaption>
      </figure>
      <p class="game-props__job">{{character.job}}</p>
      <div class="game-props__nvp">
        <span>Home Location:</span><span>{{character.homeLocation.fields.name}}</span>
        <span>Starting Boon:</span><span>{{character.startingBoon}}</span>
        <span>Starting Barrier:</span><span>{{character.startingBarrier}}</span>
      </div>
      <div class="game-props__desc" v-html="renderCharacterDescription"></div>
    </div>
    <div class="game-props__confirm">
      <font-awesome-icon icon="arrow-circle-left" class="fa-2x"
        @click="$store.commit('clearCurrentCharacter')" />
      <font-awesome-icon icon="check-circle" class="fa-2x"
        @click="confirmStart" />
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import htmlRenderer from '../../lib/cmsRichTextHtmlRenderer';

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      character: null,
      quest: null,
    };
  },
  mounted() {
    this.character = this.$store.state.currentGame.character;
    this.quest = this.$store.state.currentGame.quest;
    this.$store.commit('setShowLogo', false);
  },
  methods: {
    confirmStart() {
      this.$router.push('/quest');
    },
  },
  computed: {
    renderCharacterDescription() {
      return htmlRenderer(this.character.description);
    },
  },
};
</script>
<style lang="scss" scoped>
  img {
    width: 100%;
  }
</style>
